import { render, staticRenderFns } from "./ListMaterials.vue?vue&type=template&id=6f3b5e68&scoped=true"
import script from "./ListMaterials.vue?vue&type=script&lang=js"
export * from "./ListMaterials.vue?vue&type=script&lang=js"
import style0 from "./ListMaterials.vue?vue&type=style&index=0&id=6f3b5e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b5e68",
  null
  
)

export default component.exports